import React from "react";
import toast from "react-hot-toast";
import "./AppToast.css";

// Toasts con estética tipo "jQuery Toast" de Kapella (tarjeta de color + ícono +
// título + mensaje + cerrar), integrados a la paleta de la app. Reemplazan a los
// toast.success/error blancos por defecto de react-hot-toast.
const VARIANTS = {
  danger: { icon: "mdi-alert-circle", title: "Error" },
  success: { icon: "mdi-check-circle", title: "Listo" },
  warning: { icon: "mdi-alert", title: "Atención" },
  info: { icon: "mdi-information", title: "Información" },
};

function showToast(variant, message, title, options = {}) {
  const v = VARIANTS[variant] ?? VARIANTS.info;
  return toast.custom(
    (t) => (
      <div
        className={`app-toast app-toast--${variant} ${
          t.visible ? "app-toast--in" : "app-toast--out"
        }`}
        role="alert"
      >
        <i className={`mdi ${v.icon} app-toast__icon`} aria-hidden="true" />
        <div className="app-toast__body">
          <div className="app-toast__title">{title ?? v.title}</div>
          <div className="app-toast__msg">{message}</div>
        </div>
        <button
          type="button"
          className="app-toast__close"
          onClick={() => toast.dismiss(t.id)}
          aria-label="Cerrar"
        >
          &times;
        </button>
      </div>
    ),
    { duration: variant === "danger" ? 6000 : 4000, ...options }
  );
}

const notifyError = (message, title, options) =>
  showToast("danger", message, title, options);
const notifySuccess = (message, title, options) =>
  showToast("success", message, title, options);
const notifyWarning = (message, title, options) =>
  showToast("warning", message, title, options);
const notifyInfo = (message, title, options) =>
  showToast("info", message, title, options);

export { notifyError, notifySuccess, notifyWarning, notifyInfo };
